import { OptionType } from './types';

export const SORT_BY_YEAR_NEWEST_TO_OLDEST: OptionType = {
  label: 'New to Old',
  value: 'desc'
};
export const SORT_BY_YEAR_OLDEST_TO_NEWEST: OptionType = {
  label: 'Old to New',
  value: 'asc'
};

export const SORT_ITEMS: OptionType[] = [
  SORT_BY_YEAR_NEWEST_TO_OLDEST,
  SORT_BY_YEAR_OLDEST_TO_NEWEST
];

export const INIT_NUM_OF_VISITS_TO_FETCH = 25;
